module.exports = __webpack_public_path__ + "static/appgallery-badge-en-ff54aa0af8e09333a27edfc323f0e33f.png";